module.exports = "https://assets.pclncdn.com/web/next-landing/967f96dee0/_next/static/images/los-angeles-b282d194ac90b44a01abab53b00529de.webp";